module.exports = __webpack_public_path__ + "img/2.2.c505d939.png";